const SERVER = (process.env.REACT_APP_API_URL || 'http://localhost:5000').replace(/\/api\/?$/, '');

// Cover images are stored as "/uploads/..." (the server's address is added here) or as a full link.
export const blogImage = path => (path && path.startsWith('/') ? `${SERVER}${path}` : path || '');

export const formatBlogDate = value => (
    value ? new Date(value).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }) : ''
);

// About 200 words a minute.
export const readMinutes = text => Math.max(1, Math.round(String(text || '').split(/\s+/).filter(Boolean).length / 200));
